'use client';

import { useEffect, useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { AmericanGroupFormat } from '@/types/tournament.model';
import {
  OptionCardsField,
  AMERICAN_GROUP_FORMAT_OPTIONS,
} from '@/features/tournament-wizard/blocks/fixture-config';

interface EditAmericanGroupFormatModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentFormat: AmericanGroupFormat;
  onSave: (value: AmericanGroupFormat) => Promise<boolean>;
  isLoading: boolean;
}

export function EditAmericanGroupFormatModal({
  isOpen,
  onClose,
  currentFormat,
  onSave,
  isLoading,
}: EditAmericanGroupFormatModalProps) {
  const [format, setFormat] = useState(currentFormat);

  useEffect(() => {
    if (!isOpen) return;
    setFormat(currentFormat);
  }, [isOpen, currentFormat]);

  const handleSave = async () => {
    await onSave(format);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Formato de partidos en el grupo"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <p className="mb-4 text-sm text-muted-foreground">
          Solo formato Americano con fase de grupos. Define cómo se juegan los
          partidos dentro de cada grupo.
        </p>
        <OptionCardsField
          value={format}
          onChange={setFormat}
          options={AMERICAN_GROUP_FORMAT_OPTIONS}
          disabled={isLoading}
        />
      </div>
    </EditModal>
  );
}
